import useFetch from 'lib/hooks/useFetch';
import useComments from 'lib/hooks/useComments';

import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  Bubble,
  Card,
  flash,
  Heading,
  Icon,
} from '@frontendmentorio/design-system-v2';

import CommentCard from 'features/comments/Card';
import Form from './Form';
import GitHubAuthButton from 'features/shared/GitHubAuthButton';

export default function Feedback({ solution }) {
  const currentUser = useSelector(selectCurrentUser);
  const { create } = useComments();

  const {
    data: { data: comments },
  } = useFetch(`/api/v3/solutions/${solution.id}/comments`);

  const handleSubmit = async (data, state, methods) => {
    try {
      const comment = await create({ ...data, solution: solution.id });
      window.location.replace(`#comment-${comment.id}`);
      methods.reset();
      flash.success('Comment posted');
    } catch (error) {
      flash.error(error.message);
    }
  };

  return (
    <div className="container-xl flex flex-col gap-8" id="feedback">
      <Card className="flex flex-col gap-5 p-5">
        {currentUser ? (
          <Form onSubmit={handleSubmit} user={solution.user} withHelpText />
        ) : (
          <div className="bg-gray-100 mt-5 p-5 pt-7 relative rounded-xl">
            <Bubble className="absolute-center-x bg-neutral-300 top-[-2rem]">
              <Icon
                className="text-white text-xl"
                name="lock-keyhole"
                style="solid"
              />
            </Bubble>

            <div className="flex flex-col gap-6 items-center text-center">
              <Heading level="5" tagName="h3">
                Please log in to post a comment
              </Heading>

              <GitHubAuthButton />
            </div>
          </div>
        )}

        <div className="flex flex-col gap-5 desktop:grid desktop:grid-cols-[7fr_3fr] w-full">
          <Heading level="5" tagName="h2">
            Community feedback
          </Heading>
          {comments?.length > 0 ? (
            <ul className="col-start-1 divide-y flex flex-col overflow-hidden">
              {comments.map((comment) => (
                <li className="border-neutral-200 py-5" key={comment.id}>
                  <CommentCard comment={comment} solution={solution} />
                </li>
              ))}
            </ul>
          ) : (
            <p className="col-start-1 text-neutral-500">
              No feedback yet. Be the first to give feedback on{' '}
              {solution.user.displayName}'s solution.
            </p>
          )}
        </div>
      </Card>
    </div>
  );
}
